import { motion } from "framer-motion";
import { FaWhatsapp, FaInstagram, FaTelegram, FaFacebook, FaEnvelope } from "react-icons/fa";

const canais = [
  { key: "whatsapp", icon: <FaWhatsapp color="#25D366" />, nome: "WhatsApp" },
  { key: "instagram", icon: <FaInstagram color="#E1306C" />, nome: "Instagram" },
  { key: "telegram", icon: <FaTelegram color="#0088cc" />, nome: "Telegram" },
  { key: "facebook", icon: <FaFacebook color="#3b5998" />, nome: "Facebook" },
  { key: "email", icon: <FaEnvelope color="#d44638" />, nome: "Email" },
];

export default function DashboardMulticanal({ stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-8 px-10 py-8 bg-gradient-to-br from-indigo-900 via-blue-950 to-purple-900">
      {canais.map((c, idx) => (
        <motion.div
          key={c.key}
          initial={{ opacity: 0, scale: 0.75, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ delay: idx * 0.09, type: "spring", stiffness: 80 }}
          className="backdrop-blur-lg bg-white/10 rounded-2xl shadow-2xl p-8 flex flex-col items-center hover:scale-105 hover:shadow-indigo-500/40 transition-all border border-indigo-800"
        >
          <div className="mb-4 text-4xl drop-shadow">{c.icon}</div>
          <div className="font-extrabold text-white text-lg tracking-wide drop-shadow-sm">{c.nome}</div>
          <div className="text-white text-5xl mt-2 font-mono drop-shadow-sm">
            {stats && stats[c.key] ? stats[c.key] : 0}
          </div>
          <div className="text-xs text-indigo-200 mt-2 uppercase tracking-wider">Atendimentos</div>
        </motion.div>
      ))}
    </div>
  );
}